const hotspots = [];
export function attachListeners(config, virtualTourPlugin, planPlugin, vtv) {
    virtualTourPlugin.addEventListener("node-changed", setHotspots(config, planPlugin));
    planPlugin.addEventListener("select-hotspot", changeNode(virtualTourPlugin, vtv));
}
function setHotspots(config, planPlugin) {
    return (e) => {
        if (hotspots.length === 0) {
            config.hotspots.forEach(hotspot => {
                hotspots.push(hotspot);
            });
        }
        // filter out the node which we are currently at
        const currentGps = e.node.gps;
        planPlugin.setHotspots(hotspots.filter(h => !currentGps ||
            h.coordinates[0] !== currentGps[0] ||
            h.coordinates[1] !== currentGps[1]));
    };
}
function changeNode(virtualTourPlugin, vtv) {
    return (e) => {
        const id = e.hotspotId;
        if (id.startsWith("__tour-hotspot__")) {
            virtualTourPlugin.setCurrentNode(id.substring(16));
        }
        else if (id.startsWith("__cross-hotspot__")) {
            const startNodeId = id.substring(17);
            const configUrl = hotspots.find(h => h.id === id)?.data?.loadTourConfigUrl;
            if (!configUrl)
                return;
            vtv.switchTour({
                configUrl,
                startNodeId,
            });
        }
    };
}
